import { render, staticRenderFns } from "./perant.vue?vue&type=template&id=7b3ded6e&"
import script from "./perant.vue?vue&type=script&lang=js&"
export * from "./perant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports